import React, { useMemo, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Table,
  Spinner,
  Alert,
  Badge,
} from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { FaFileExcel, FaSearch, FaMoneyBillWave } from "react-icons/fa";
import pythonApiClient from "../../../services/api/pythonBaseApi";
import "react-toastify/dist/ReactToastify.css";

const SERVICIOS = [
  "C. STAFF",
  "C. WORKER",
  "MOD. GERENCIA",
  "MOD. H",
  "MOD. STAFF",
];

const defaultFechas = () => {
  const hoy = new Date();
  const fin = hoy.toISOString().slice(0, 10);
  const ini = new Date(hoy.getFullYear(), hoy.getMonth(), 1)
    .toISOString()
    .slice(0, 10);
  return { fecha_inicio: ini, fecha_fin: fin };
};

const ReporteValorizacionHoteleria = () => {
  const selectedProject = JSON.parse(
    localStorage.getItem("selectedProject") || "null"
  );
  const defaults = defaultFechas();

  const [filtros, setFiltros] = useState({
    fecha_inicio: defaults.fecha_inicio,
    fecha_fin: defaults.fecha_fin,
  });
  const [loading, setLoading] = useState(false);
  const [exportando, setExportando] = useState(false);
  const [error, setError] = useState(null);
  const [resultado, setResultado] = useState(null);

  const valorizacion = resultado?.resumen?.valorizacion;
  const porServicio = resultado?.resumen?.por_servicio || {};

  const params = useMemo(
    () => ({
      fecha_inicio: filtros.fecha_inicio,
      fecha_fin: filtros.fecha_fin,
    }),
    [filtros]
  );

  const consultar = async () => {
    if (!selectedProject?.id) {
      toast.error("Seleccione un proyecto");
      return;
    }
    if (!filtros.fecha_inicio || !filtros.fecha_fin) {
      toast.error("Indique el periodo");
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const response = await pythonApiClient.get(
        "/reportes/hoteleria/valorizacion/",
        {
          params,
          headers: { "X-Proyecto-ID": selectedProject.id },
          timeout: 180000,
        }
      );
      setResultado(response.data);
      toast.success(response.data?.message || "Reporte generado");
    } catch (err) {
      console.error(err);
      const msg =
        err.response?.data?.detail ||
        err.message ||
        "No se pudo generar el reporte";
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  const descargarExcel = async () => {
    if (!selectedProject?.id) {
      toast.error("Seleccione un proyecto");
      return;
    }
    setExportando(true);
    try {
      const response = await pythonApiClient.get(
        "/reportes/hoteleria/valorizacion/excel",
        {
          params,
          headers: { "X-Proyecto-ID": selectedProject.id },
          responseType: "blob",
          timeout: 300000,
        }
      );
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `valorizacion_hoteleria_${filtros.fecha_inicio}_${filtros.fecha_fin}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      toast.success("Excel descargado");
    } catch (err) {
      console.error(err);
      toast.error(
        err.response?.data?.detail || err.message || "Error al exportar Excel"
      );
    } finally {
      setExportando(false);
    }
  };

  return (
    <div className="dh-reporte-bg">
      <style>{`
        .dh-reporte-bg {
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
          min-height: 100vh;
          padding-bottom: 2rem;
        }
        .dh-main-header {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          padding: 2rem 0;
          margin-bottom: 2rem;
          border-radius: 0 0 30px 30px;
          box-shadow: 0 10px 30px rgba(102, 126, 234, 0.2);
        }
        .dh-main-title { font-size: 2rem; font-weight: 700; margin: 0; }
        .dh-main-subtitle { font-size: 1rem; opacity: 0.9; margin: 0.5rem 0 0 0; }
        .dh-card {
          border: none;
          border-radius: 20px;
          box-shadow: 0 15px 35px rgba(0,0,0,0.1);
          background: white;
        }
        .dh-card-header {
          border-radius: 20px 20px 0 0;
          padding: 1.25rem 1.5rem;
          border: none;
          font-weight: 700;
        }
        .dh-card-header-primary {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
        }
        .dh-card-header-success {
          background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
          color: white;
        }
        .btn-dh-primary {
          background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
          border: none;
          color: white;
          border-radius: 12px;
          padding: 10px 18px;
          font-weight: 600;
        }
        .btn-dh-secondary {
          background: linear-gradient(135deg, #6b7280 0%, #374151 100%);
          border: none;
          color: white;
          border-radius: 12px;
          padding: 10px 18px;
          font-weight: 600;
        }
        .dh-form-label { font-weight: 600; color: #374151; }
        .dh-form-control { border-radius: 10px; }
        .dh-alert-info {
          background: linear-gradient(135deg, #e0f2fe 0%, #dbeafe 100%);
          border: 1px solid #93c5fd;
          border-radius: 12px;
          padding: 1rem 1.25rem;
          color: #1e40af;
        }
        .stat-box {
          text-align: center;
          padding: 1rem;
          border-radius: 12px;
          background: #f8fafc;
          border: 1px solid #e2e8f0;
        }
        .stat-box h4 { margin: 0; font-weight: 700; }
        .stat-box small { color: #64748b; }
      `}</style>

      <div className="dh-main-header">
        <Container>
          <h1 className="dh-main-title">
            <FaMoneyBillWave className="me-2" />
            Valorización Hotelería
          </h1>
          <p className="dh-main-subtitle">
            Hombre/día por servicio (STAFF / WORKER / módulos) con costos e IGV
          </p>
        </Container>
      </div>

      <Container>
        <div className="dh-alert dh-alert-info mb-4">
          El reporte cuenta noches de estadía con check-in en el periodo,
          clasifica por zona/módulo (ASI/AUX→MOD. H, STAFF→MOD. STAFF,
          JEF→MOD. GERENCIA, carpas→C. WORKER/C. STAFF) y genera el Excel con
          hojas VALORIZACION, RESUMEN, DETALLES, USUARIOS y BBDD.
        </div>

        <Card className="dh-card mb-4">
          <Card.Header className="dh-card-header dh-card-header-primary">
            Filtros
          </Card.Header>
          <Card.Body>
            <Row className="g-3 align-items-end">
              <Col md={3}>
                <Form.Label className="dh-form-label">Fecha inicio</Form.Label>
                <Form.Control
                  type="date"
                  className="dh-form-control"
                  value={filtros.fecha_inicio}
                  onChange={(e) =>
                    setFiltros((p) => ({ ...p, fecha_inicio: e.target.value }))
                  }
                />
              </Col>
              <Col md={3}>
                <Form.Label className="dh-form-label">Fecha fin</Form.Label>
                <Form.Control
                  type="date"
                  className="dh-form-control"
                  value={filtros.fecha_fin}
                  onChange={(e) =>
                    setFiltros((p) => ({ ...p, fecha_fin: e.target.value }))
                  }
                />
              </Col>
              <Col md={6} className="d-flex flex-wrap gap-2">
                <Button
                  className="btn-dh-primary"
                  onClick={consultar}
                  disabled={loading || exportando}
                >
                  {loading ? (
                    <Spinner size="sm" className="me-2" />
                  ) : (
                    <FaSearch className="me-2" />
                  )}
                  Consultar
                </Button>
                <Button
                  className="btn-dh-secondary"
                  onClick={descargarExcel}
                  disabled={loading || exportando}
                >
                  {exportando ? (
                    <Spinner size="sm" className="me-2" />
                  ) : (
                    <FaFileExcel className="me-2" />
                  )}
                  Descargar Excel
                </Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {error && (
          <Alert variant="danger" className="mb-4">
            {error}
          </Alert>
        )}

        {resultado && (
          <>
            {(resultado.resumen?.sin_tarifa_configurada || 0) > 0 && (
              <Alert className="dh-alert dh-alert-info mb-4">
                Hay{" "}
                <strong>{resultado.resumen.sin_tarifa_configurada}</strong>{" "}
                hombre/día calculados con tarifa heurística (módulos sin tarifa
                asignada). Configure tarifas en{" "}
                <a href="/mantenimientos/hoteleria/tipos-valorizacion">
                  Tarifas Valorización
                </a>{" "}
                y asígnelas en cada módulo.
              </Alert>
            )}
            <Row className="g-3 mb-4">
              <Col xs={6} md={3}>
                <div className="stat-box">
                  <h4>{resultado.detalles_count ?? 0}</h4>
                  <small>Hombre/día total</small>
                </div>
              </Col>
              {SERVICIOS.map((s) => (
                <Col key={s} xs={6} md={2}>
                  <div className="stat-box">
                    <h4>{porServicio[s] ?? 0}</h4>
                    <small>{s}</small>
                  </div>
                </Col>
              ))}
            </Row>

            <Card className="dh-card mb-4">
              <Card.Header className="dh-card-header dh-card-header-success">
                Valorización
                {valorizacion && (
                  <Badge bg="light" text="dark" className="ms-2">
                    Total S/ {Number(valorizacion.total || 0).toLocaleString("es-PE", { minimumFractionDigits: 2 })}
                  </Badge>
                )}
              </Card.Header>
              <Card.Body>
                <Table striped bordered hover responsive className="mb-0">
                  <thead>
                    <tr>
                      <th>Servicio</th>
                      <th>Und</th>
                      <th>Costo</th>
                      <th>Cantidad</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(valorizacion?.lineas || []).map((l) => (
                      <tr key={l.servicio}>
                        <td>{l.servicio}</td>
                        <td>{l.und}</td>
                        <td>{Number(l.costo).toFixed(2)}</td>
                        <td>{l.cantidad}</td>
                        <td>{Number(l.total).toLocaleString("es-PE", { minimumFractionDigits: 2 })}</td>
                      </tr>
                    ))}
                    <tr>
                      <td colSpan={4} className="text-end fw-semibold">
                        Sub Total
                      </td>
                      <td className="fw-semibold">
                        {Number(valorizacion?.subtotal || 0).toLocaleString("es-PE", { minimumFractionDigits: 2 })}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={4} className="text-end">
                        IGV ({Math.round((valorizacion?.igv_tasa || 0) * 100)}%)
                      </td>
                      <td>
                        {Number(valorizacion?.igv || 0).toLocaleString("es-PE", { minimumFractionDigits: 2 })}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={4} className="text-end fw-bold">
                        TOTAL
                      </td>
                      <td className="fw-bold">
                        {Number(valorizacion?.total || 0).toLocaleString("es-PE", { minimumFractionDigits: 2 })}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Card.Body>
            </Card>

            <Card className="dh-card">
              <Card.Header className="dh-card-header dh-card-header-primary">
                Muestra DETALLES (primeras 100 filas)
              </Card.Header>
              <Card.Body>
                <div style={{ maxHeight: 420, overflow: "auto" }}>
                  <Table striped bordered hover responsive size="sm" className="mb-0">
                    <thead>
                      <tr>
                        <th>Bloque</th>
                        <th>Módulo</th>
                        <th>Tipo</th>
                        <th>Hab</th>
                        <th>Cama</th>
                        <th>DNI</th>
                        <th>Nombre</th>
                        <th>F. Reporte</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(resultado.detalles_sample || []).length === 0 ? (
                        <tr>
                          <td colSpan={8} className="text-center text-muted py-3">
                            Sin noches en el periodo
                          </td>
                        </tr>
                      ) : (
                        (resultado.detalles_sample || []).map((f, idx) => (
                          <tr key={`${f.DNI}-${f["F. REPORTE"]}-${idx}`}>
                            <td>{f.BLOQUE}</td>
                            <td>{f.MODULO}</td>
                            <td>
                              <Badge bg="secondary">{f["TIPO DE CARPA"]}</Badge>
                            </td>
                            <td>{f.HAB}</td>
                            <td>{f.CAMA}</td>
                            <td>{f.DNI}</td>
                            <td>{f["APELLIDOS Y NOMBRES"]}</td>
                            <td>{f["F. REPORTE"]}</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                </div>
              </Card.Body>
            </Card>
          </>
        )}
      </Container>

      <ToastContainer position="bottom-right" />
    </div>
  );
};

export default ReporteValorizacionHoteleria;
